import { createFileRoute } from "@tanstack/react-router";
import { TaskDetail } from "@/components/TaskDetail";

function Page() {
  const { taskId } = Route.useParams();
  return <TaskDetail taskId={taskId} />;
}
export const Route = createFileRoute("/tasks/$taskId")({ component: Page });
